import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import clsx from 'clsx';

type MarkdownContainerProps = {
  children: string;
  className?: string;
};

export const MarkdownContainer: React.FC<MarkdownContainerProps> = ({
  children,
  className,
}) => {
  return (
    <Markdown
      rehypePlugins={[rehypeRaw]}
      className={clsx('markdown', className)}
    >
      {children}
    </Markdown>
  );
};
